// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2HA4o","validationTips":"StatementDescriptor_validationTips__3FYfO"};